import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowRight } from 'lucide-react';
import Button from '../common/Button';

export default function Hero() {
  return (
    <div className="relative min-h-screen flex items-center">
      <div className="absolute inset-0 z-0">
        <img
          src="https://images.unsplash.com/photo-1451187580459-43490279c0fa?auto=format&fit=crop&q=80"
          alt="Bitcoin background"
          className="w-full h-full object-cover brightness-50"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/30 to-purple-900/40" />
      </div>
      <div className="container mx-auto px-4 relative z-10 pt-20">
        <div className="max-w-2xl text-white">
          <h1 className="text-6xl font-bold mb-4 leading-tight">
            Transform
            <span className="block text-transparent bg-clip-text bg-gradient-to-r from-purple-400 to-purple-600">
              Your Banking
            </span>
          </h1>
          <div className="flex flex-col gap-2 mb-6">
            <p className="text-lg text-purple-300 font-semibold">✓ Instant Cash to Bitcoin Conversion</p>
            <p className="text-lg text-purple-300 font-semibold">✓ Bank-Grade Security Standards</p>
            <p className="text-lg text-purple-300 font-semibold">✓ Live Support - Always Available</p>
          </div>
          <p className="text-xl mb-8 text-gray-300">
            Join the future of finance with our network of Bitcoin ATMs across Texas.
            Fast, secure, and available 24/7.
          </p>
          <div className="flex space-x-4">
            <Link to="/locations">
              <Button>
                <span>Find a BTM</span>
                <ArrowRight className="w-5 h-5 ml-2" />
              </Button>
            </Link>
            <Link to="/host">
              <Button variant="secondary">
                <span>Host a BTM</span>
              </Button>
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
}